import styles from "./BarLoader.module.css";

const BAR_COUNT = 7;

function BarLoader({ label = "Preparing to Ignite" }) {
  return (
    <div
      className={styles["loader-wrap"]}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className={styles.chassis} aria-hidden="true">
        <div className={styles.glow} />
        <div className={styles.equalizer}>
          {Array.from({ length: BAR_COUNT }, (_, i) => (
            <span key={i} className={styles.bar} style={{ "--bar-i": i }} />
          ))}
        </div>
        <p className={styles.label}>{label}</p>
      </div>
    </div>
  );
}

export default BarLoader;
